<template>

   <ion-page id="email-verify-page">
    <ion-content>

        <TopLine :style="styleTopline" :title="emailVerificationTitleString" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>
   
        <div :style="styleMiddle">
          <ion-item>
            <ion-label>
              <h1>{{ translatePhrase("Email Verification Check") }}</h1>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label v-if="hasError" class="danger">
              {{ message }}
            </ion-label>
            <ion-label v-if="!hasError">
              {{ message }}
            </ion-label>
            </ion-item>
        </div>
    <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />  
    </ion-content>
  </ion-page>
</template>

<script setup>

  // https://stackoverflow.com/questions/35914069/how-can-i-get-query-parameters-from-a-url-in-vue-js

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';

  import { computed } from "@vue/reactivity"
  import { ref, watch } from 'vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { useGetData } from '@/composables/getData.js'
  import ToolBar from '@/components/ToolBar.vue'
  import { doStartupCheck } from '../../composables/startupCheck.js'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import { parseWordsSaid , parseGeneralWordsSaid } from '@/composables/wordlistSupport.js'
  import TopLine from '@/components/TopLine.vue'
  import { useRouter } from 'vue-router';
  import { translateEnglishWords, translatePhrase } from '@/composables/translation.js';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const isDark = ref(connectionStore.getDarkmode != "light")

  const emailVerificationTitleString = translatePhrase("Email Verification")
  const urlParams =  new URLSearchParams(window.location.search)

  const wordlist = "command done mute listen ignore"
  emit("word-list",wordlist)

  const wordlistTrigger = ref(0)

  const TOOLBAR_DONE = 0

  const toolbarElements = ref([])
  const toolbarTrigger = ref(0)

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const hasError = ref(false)
  const message = ref("")
  var verify = ""
  var email = ""

  var url_v = localStorage.getItem("url_v")
  var url_e = localStorage.getItem("url_e")
  if (url_v == null || url_e == null) {
    hasError.value = true
    message.value = "The necessary URL parameters aren't there. If this persists, please contact support@chessvis.com"
  }
  else {
    hasError.value = false
    verify = url_v
    email = decodeURIComponent(url_e)
    sendVerification(verify,email)
  }

  function processJsonResponse (json) {
    //console.log(" ******** email verification callback",json)
    if (json.hasOwnProperty('error')) {
      alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
    switch (json['stat']) {
      case 'g' :
        message.value = translatePhrase("Email Verified")
        hasError.value = false
        break
      default :
        message.value = json['stat']
        hasError.value = true
        break;
    }
    doStartupCheck(true)
  }

  watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

   watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  function sendVerification(verify,email) {
    message.value = translatePhrase("processing email verification") + "...."
    var formData = { 
      e : email, 
      v : verify 
    }
    useGetData("process_email_verification.php", formData, processJsonResponse)
  }

  function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function toolbarClick(arrayIndex) {
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore" || currentWord == "mute" || currentWord == "listen") {
            return [currentWord,""];
        }
        if (currentWord == "done") {
            return ["done",""]
        }
       
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }

  function processWords(text) {
    //console.log("text in Connect ",text)
    var returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "done" :
        emit("where-next","/")
        break
    }
  }

</script>

<style scoped>

</style>
